package com.ragnorak.clanybackoffice.ui.screens

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.clany.backoffice.domain.usecase.GetSubscriptionsUseCase
import com.clany.backoffice.domain.usecase.UpdateSubscriptionUseCase
import com.clany.backoffice.model.SubscriptionResponse
import dev.zacsweers.metro.Inject
import kotlinx.coroutines.launch

data class SubscriptionsUiState(
    val isLoading: Boolean = false,
    val subscriptions: List<SubscriptionResponse> = emptyList(),
    val error: String? = null,
    val page: Int = 1,
    val hasMore: Boolean = true,
    val searchQuery: String = "",
    val editingSubscription: SubscriptionResponse? = null
)

class SubscriptionsViewModel @Inject constructor(
    private val getSubscriptionsUseCase: GetSubscriptionsUseCase,
    private val updateSubscriptionUseCase: UpdateSubscriptionUseCase
) : ViewModel() {

    var uiState by mutableStateOf(SubscriptionsUiState())
        private set

    init {
        loadSubscriptions()
    }

    fun loadSubscriptions(page: Int = 1) {
        viewModelScope.launch {
            uiState = uiState.copy(isLoading = true, error = null)
            getSubscriptionsUseCase(
                page = page,
                pageSize = 20,
                query = uiState.searchQuery.ifBlank { null }
            )
                .onSuccess { subs ->
                    uiState = uiState.copy(
                        isLoading = false,
                        subscriptions = if (page == 1) subs else uiState.subscriptions + subs,
                        page = page,
                        hasMore = subs.isNotEmpty()
                    )
                }
                .onFailure {
                    uiState = uiState.copy(isLoading = false, error = it.message)
                }
        }
    }

    fun onSearchQueryChanged(query: String) {
        uiState = uiState.copy(searchQuery = query)
        loadSubscriptions(page = 1)
    }

    fun onEditSubscription(sub: SubscriptionResponse) {
        uiState = uiState.copy(editingSubscription = sub)
    }

    fun dismissEdit() {
        uiState = uiState.copy(editingSubscription = null)
    }

    fun updatePlan(id: String, plan: String, status: String) {
        viewModelScope.launch {
            uiState = uiState.copy(isLoading = true)
            updateSubscriptionUseCase(id, plan, status)
                .onSuccess {
                    val updated = uiState.subscriptions.map { s ->
                        if (s.id == id) s.copy(plan = plan, status = status) else s
                    }
                    uiState = uiState.copy(isLoading = false, subscriptions = updated, editingSubscription = null)
                }
                .onFailure {
                    uiState = uiState.copy(isLoading = false, error = it.message)
                }
        }
    }
}
